module.exports = __webpack_public_path__ + "static/4+-691386204d42f9310fc0c0ea3408aca3.mp4";